<template>
    <router-view></router-view>
</template>

<script>
    import PageOptions from '@/Options/PageOptions.js'

    export default {
        metaInfo: {
            titleTemplate: '%s - AHM Sparepart',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        },
        components: {
        },
        data() {
            return {
                pageOptions: PageOptions,
                alert: this.$store.getters.getAlertStatus,
                alertDuration: 5000,//in ms
            }
        },
        created() {
            this.pageOptions.pageEmpty = false;
        },
        mounted() {
            this.checkAlert();
        },
        watch: {
            '$store.getters.getAlertStatus': function () {
                this.alert = this.$store.getters.getAlertStatus;
                this.checkAlert();
            }
        },
        beforeRouteLeave(to, from, next) {
            PageOptions.pageEmpty = true;
            next();
        },
        methods: {
            checkAlert() {
                setTimeout(() => {
                    if (this.alert.showAlert) this.$store.dispatch('setShowAlert', false);
                }, this.alertDuration);
            }
        }
    }
</script>

<style>
    @font-face {
        font-family: 'Montserrat';
        src: url('/font/Monserrat/Montserrat-Regular.ttf') format('truetype');
    }

    * {
        /* font-family: 'Proxima Nova'; */
        /* font-weight: bold; */
    }

    /* ALERT MESSAGE STARTS */
    .alertmessage {
        position: fixed;
        top: 10%;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 9999;
        width: 300px;
        text-align: center;
    }

    .alertmessage strong {
        font-size: 150%
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .title {
        display: flex;
        align-items: center;
    }

    .btn-green {
        background-color:#43B254 !important;
        color:white !important;
    }

    .btn-dark-blue {
        background-color: #134F97 !important;
        color: white !important;
    }

    .btn-dark-blue-outline {
        color : #134F97 !important;
        border : 1px solid #134F97 !important;
        
    }

    .btn-lg-grey {
        background-color :#D3D8DE !important;
        color : #7D8DA0 !important;
    }


    .form-control {
        height: 43px;
    }

    /* ALERT MESSAGE ENDS */
</style>

<style>
    .modal-mask {
        position: fixed;
        z-index: 1050;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 10px 0;
    }

    .modal-default-button {
        float: right;
    }

    .bg-white {
        background-color: white;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body{
        margin:0
    }

    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a{
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }

    h3.modalHeadline{
        margin:0 0 20px 0
    }
    /* MODAL ENDS */

    .modalContent tr th{
      text-align:right;
    }

    .modalContent tr .middleDivider{
      width: 50px;
      text-align: center;
    }
</style>

    